import { useState, useMemo } from "react";
import { w as withMetadataArgument, g as getCountryCallingCode } from "../../../../../getCountryCallingCode-1d4ae7fd.js";
import { n as normalizeArguments, p as parsePhoneNumberWithError$2 } from "../../../../../normalizeArguments-0e96c5c2.js";
function parsePhoneNumberWithError$1() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
  return parsePhoneNumberWithError$2(text, options, metadata);
}
function parsePhoneNumberWithError() {
  return withMetadataArgument(parsePhoneNumberWithError$1, arguments);
}
function usePhoneNumberInput(options = {}) {
  const { defaultCountryCode, fullNumber: defaultFullNumber } = options, [selectedCountry, setSelectedCountry] = useState(), [fullNumber, setFullNumber] = useState(defaultFullNumber || ""), [phoneNumber, setPhoneNumber] = useState(removeCountryCodeFromFullNumber(defaultFullNumber)), defaultCountryCodeMemo = useMemo(
    () => getCountryCodeFromFullNumber(fullNumber) || defaultCountryCode || "US",
    /* eslint-disable-next-line react-hooks/exhaustive-deps --
     *   should only be computed on initial render
     */
    []
  );
  function onChange(value) {
    setPhoneNumber(value.phoneNumber || ""), setFullNumber(value.fullNumber), setSelectedCountry(value.selectedCountry);
  }
  return {
    onChange,
    phoneNumber,
    fullNumber,
    selectedCountryCode: selectedCountry == null ? void 0 : selectedCountry.countryCode,
    defaultCountryCode: defaultCountryCodeMemo
  };
}
function removeCountryCodeFromFullNumber(fullNumber, countryCode) {
  if (!fullNumber || !countryCode)
    return "";
  const countryCodeNumber = `+${getCountryCallingCode(countryCode)}`;
  return fullNumber.replace(countryCodeNumber, "");
}
function getCountryCodeFromFullNumber(fullNumber) {
  return fullNumber ? parsePhoneNumberWithError(fullNumber).country : void 0;
}
export {
  usePhoneNumberInput
};
//# sourceMappingURL=usePhoneNumberInput.js.map
